<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX19gbbTTwAUee8flNU16hRHCk49zFgJOG24=",
    "cpf": "U2FsdGVkX1+eUFOpB5PfK/8+A2pE61yopCTra/mYkPI="
  },
  {
    "num_cand": "U2FsdGVkX1/96dCFBBTHkB9GpcVAcEnRof02OdiJaLk=",
    "cpf": "U2FsdGVkX1++SQ1mMOq+WfI4e70vUykcktJZ0xs10Lg="
  },
  {
    "num_cand": "U2FsdGVkX18vVFxBae568f2k1VqmWUDIX5bidN3FZZo=",
    "cpf": "U2FsdGVkX1+zb7l3ga/ybZwZTw8dDaMiB/atyEHkL5U="
  },
  {
    "num_cand": "U2FsdGVkX19md77+sgQIW7U+Futnn4ryG6X3IJb+dro=",
    "cpf": "U2FsdGVkX18WaJAEQMDqOOj+0MrzVrS6jWfFRN4fIhg="
  },
  {
    "num_cand": "U2FsdGVkX18lj8NoxG8HDQM7lDbDEfPzgr13n4Wa7Qw=",
    "cpf": "U2FsdGVkX1+zKnhLKT89XClQf1QrBgdwbSHleK76QOY="
  },
  {
    "num_cand": "U2FsdGVkX19tP7OeMlVL3uoFBj7m2zkpK4zeH3WEbTI=",
    "cpf": "U2FsdGVkX1+FgZ49NhrQ5ffR97hTSNSwefUgTQPVh+8="
  },
  {
    "num_cand": "U2FsdGVkX19PP8bKiMq0+dHtfdZb5ppC+gEJpd3S+90=",
    "cpf": "U2FsdGVkX197N1wdr7SXlX4jPrYnwO4XP/7eaW+H1w0="
  },
  {
    "num_cand": "U2FsdGVkX19HjcjOO9CRM6JpdJmX7ej3IDIXdlCBULw=",
    "cpf": "U2FsdGVkX19hRV3Q7ptz78e4olVbJGvyL1Er5taYNIc="
  },
  {
    "num_cand": "U2FsdGVkX1+l55Znf6UNoLPitH7oRH0T0PuqmLPQ5+k=",
    "cpf": "U2FsdGVkX1/j6W1lAfWeZQkDtP9x0vyglF61uG1rKpE="
  },
  {
    "num_cand": "U2FsdGVkX19sAVDPsUFwWr/hNF+PdAhDNv52hI82Kwc=",
    "cpf": "U2FsdGVkX1/TJM8Pekpz/ngIoUH4FfgUtxXmMzFCYjQ="
  },
  {
    "num_cand": "U2FsdGVkX1/KWoeGHecutxrIgBVTX0kOwN9KuzQqihc=",
    "cpf": "U2FsdGVkX19duiBjZFn7WGEd6RMOb9963WseeuJgfsM="
  },
  {
    "num_cand": "U2FsdGVkX18sqxrtRSlTP0rwUgiBowq5dX46JG+IGSU=",
    "cpf": "U2FsdGVkX1+dsbOBJ5IutIZqu+AuTimCZdgq3+MavYs="
  },
  {
    "num_cand": "U2FsdGVkX18gmr5mayz3nc23SHPEvP51qXlD+G44wSg=",
    "cpf": "U2FsdGVkX19rah1zjMdFMiMaFTG4NqBQq7TgE5FDfBk="
  },
  {
    "num_cand": "U2FsdGVkX19Cfuw7x8jsRCaCUVptfqPGjXr4De9v4qo=",
    "cpf": "U2FsdGVkX19IDVlsGqkIrUBMbF7rBOYP/Ao8A/f9nsU="
  },
  {
    "num_cand": "U2FsdGVkX19FZiYyFLALOP7nrMGBC8dWycOS88Ebkm4=",
    "cpf": "U2FsdGVkX1+IoohptIydJ85YFYWXBfz7AYzmxiTbZu0="
  },
  {
    "num_cand": "U2FsdGVkX18/uXbEO4aEhzUhlXxx8mvFZL2auNIed14=",
    "cpf": "U2FsdGVkX1+0TzCy+0fpRGjm9lXgTDokW1kxDlSYSU0="
  },
  {
    "num_cand": "U2FsdGVkX1/G1GNtCDSyPdpHXkydyVWOvpvhidPRXiE=",
    "cpf": "U2FsdGVkX19t0LSeFFNVn7dmM6lXdn28N7xwLrk+YHc="
  },
  {
    "num_cand": "U2FsdGVkX18T7j6B+PKp3+w+UePWAIOoWkTbhdD9QEA=",
    "cpf": "U2FsdGVkX18cSiB6bw1pGBxauKcmo/BWBhYe+4MQ49o="
  },
  {
    "num_cand": "U2FsdGVkX19PNdcVVRtrjJZW6X6lVw94n4+W6KZTPcM=",
    "cpf": "U2FsdGVkX1/sbdppLtnPXLd1GUcqXHYFCDxW0gfcz4Q="
  },
  {
    "num_cand": "U2FsdGVkX1/6svG8Fq4sU6iwCaZ40dRuRfPqrQvK/3Y=",
    "cpf": "U2FsdGVkX19z3AMTPlZKUXm7zqqswT/ehsLhKnU/WpM="
  },
  {
    "num_cand": "U2FsdGVkX1+OoWE3ipS4C1qpvRTDsWXwptjnVD4qKp8=",
    "cpf": "U2FsdGVkX18akwnkCAmCNrPZaYbkOyfQ25awf6TZViU="
  },
  {
    "num_cand": "U2FsdGVkX1988u0OdDleTbqaqEradtz7E/vzn1IR5kI=",
    "cpf": "U2FsdGVkX19PC/2/+X8e+4oqf1LSrkRF4TJo9Jlcbt0="
  },
  {
    "num_cand": "U2FsdGVkX1/aKF69XUyCW5ydWq+08yyGoDKCs1KNt5A=",
    "cpf": "U2FsdGVkX1/8uVvu6aHAYzr6ssK16AINNvpvCYGgzNI="
  },
  {
    "num_cand": "U2FsdGVkX19BqTj7kac+X6yz8Y9CmFplyo4EkhUy17M=",
    "cpf": "U2FsdGVkX18BVqK+YMUcAMwVlmFAm1v0LFrDsEYoVGI="
  },
  {
    "num_cand": "U2FsdGVkX18QGSNfXJxt1eH5I6hA4k4HzaH3/Fj27NE=",
    "cpf": "U2FsdGVkX19zbe4uUrKM24W5FGHOv0zJ+6T92Fb3GB8="
  },
  {
    "num_cand": "U2FsdGVkX1+VC7m01nQawx/HpPYEmcZG2V6Ocz7RYkQ=",
    "cpf": "U2FsdGVkX19grVx32WIrzDn3CD8mfbDxRyXTgMswCYk="
  },
  {
    "num_cand": "U2FsdGVkX1/kbAWDAG0sIYpLUO62ti0qH9zYoQ8Lc0c=",
    "cpf": "U2FsdGVkX19sgtH6HRAfejlXB8Hxav9bMN+WOrPQUqQ="
  },
  {
    "num_cand": "U2FsdGVkX1+cg+3IFlGGGLUQ7ODL01M/WG1GmyYWpRE=",
    "cpf": "U2FsdGVkX1/70CtdKIOGDx9peP0F7DKwAAojTzZLu4w="
  },
  {
    "num_cand": "U2FsdGVkX1//TEE3MG+tnvozR6nNiblUxn00xD9Xf1s=",
    "cpf": "U2FsdGVkX1/EwgH0cwVxU5MT+ghFpP/NTpp5Byit8IY="
  },
  {
    "num_cand": "U2FsdGVkX19ZOz3Xs4Bmq659soP4eSTWgEFhJz/zgDU=",
    "cpf": "U2FsdGVkX19/ax15SyN5flAawd4jqNFppblGee1JX3Y="
  },
  {
    "num_cand": "U2FsdGVkX19vgROBClKYY1BiYJjZ4LjbgWxv076CDFo=",
    "cpf": "U2FsdGVkX19xwKBVL/CARtvyJXIOBM4uiHGSwrPdry8="
  },
  {
    "num_cand": "U2FsdGVkX19WfJeOpHa774vCaoSCWv0MhOGkAia1/yI=",
    "cpf": "U2FsdGVkX18dUgrDuiPgis+ZDVs/SQVPsMcF8IHxKkQ="
  },
  {
    "num_cand": "U2FsdGVkX1/kN6qgyptdiSVwNAfg1SmW9e8Aby4w0Qc=",
    "cpf": "U2FsdGVkX19rqaHAwHe4aGWBJDJndRAiHWWGbdC/sGk="
  },
  {
    "num_cand": "U2FsdGVkX19zpg8gTIYEvoU3dCRPGtNaqXA9sqZBaR4=",
    "cpf": "U2FsdGVkX1/BmrK/wku38T307PxJz4QbxD6GCPbjYnA="
  },
  {
    "num_cand": "U2FsdGVkX19bx/qCrVwBGYB4VOf0wE37uegsNS3LJhQ=",
    "cpf": "U2FsdGVkX1+Q/3fH5QqOnhvjMboWIgxGSAWyNGowRG4="
  },
  {
    "num_cand": "U2FsdGVkX1/BMCsDpRNZdY7bfqcqSY91Lb0Bm6+EFO8=",
    "cpf": "U2FsdGVkX1/caidPAjUoJjhsOrbPITgNR47BmVUlroM="
  },
  {
    "num_cand": "U2FsdGVkX19KIdEowSgVSjnJPWvxVqy3pD9wzHzZQ9I=",
    "cpf": "U2FsdGVkX18Mwnxz+sZl7At0QwhdzQspbB5JQbeY/5s="
  },
  {
    "num_cand": "U2FsdGVkX19nIxcDdavTn4iKsTrTxzLmVk6+Sg+N64Y=",
    "cpf": "U2FsdGVkX1+7f7wPdoaDkW+hejnExHayj1l9848xyRs="
  },
  {
    "num_cand": "U2FsdGVkX19cqh2yTpcEcpkvM5kEc5tn4lhFxQGFU2w=",
    "cpf": "U2FsdGVkX18BL3wXbQWDRtKkqtCYwOW32E6lW1K9G7g="
  },
  {
    "num_cand": "U2FsdGVkX18yOfQb1Y/ae9023ILE+b5pEq4aRZl6hSk=",
    "cpf": "U2FsdGVkX18oS/Z55ITkL5alb3WMK4iTMX2KmYBnzWg="
  },
  {
    "num_cand": "U2FsdGVkX1/JdEMjMGNwY/iftURqkHDv7b4sb7pM/zA=",
    "cpf": "U2FsdGVkX19PVAEwKpKkUq7kmUCKQEFw63AnzZrEucQ="
  },
  {
    "num_cand": "U2FsdGVkX19qjLvDH8lRQNhrxqV1WZqRNlNoOQvZnEM=",
    "cpf": "U2FsdGVkX1/ZvjIEIq+Tp1H1B6uJjHI1WLyrUzehT6k="
  },
  {
    "num_cand": "U2FsdGVkX18wr9smPmgxGBBqc+TFx9PJkyJZWaeje7A=",
    "cpf": "U2FsdGVkX18tA88Zo3k/PJfZ8L2Ghd1Z0+/ooeWZK/w="
  },
  {
    "num_cand": "U2FsdGVkX18+7yz+pMyskmqtjUXy0wEBo23ZVm+0VnY=",
    "cpf": "U2FsdGVkX18R8WXmcHIbp8twkLk7Zpw6uIvXUUN8KGw="
  },
  {
    "num_cand": "U2FsdGVkX1+5a+RPvNBpqZe7hkYJQezPSF6RHrlFYn0=",
    "cpf": "U2FsdGVkX19gkpJ3ZDTdJOTnIr3tUB2+CEpc1iHfBIc="
  },
  {
    "num_cand": "U2FsdGVkX1//7i7Z7jhnFyF/rg4YfWOigynvAB/0P3A=",
    "cpf": "U2FsdGVkX19nSwFybmxsvZ4yCZBWCbHedYxP6JePHRk="
  },
  {
    "num_cand": "U2FsdGVkX1+QyzOQtZq7YjowWB2eArB3dPl4lItW0DQ=",
    "cpf": "U2FsdGVkX1+MwY44FPPf0Snq/acGdDY/2+UFkBa7bf0="
  },
  {
    "num_cand": "U2FsdGVkX1/bPjLeL+4bA0sDLuwlD+yt9bycgCNBPU0=",
    "cpf": "U2FsdGVkX18PvdcVNaJQE/iY6qt3AiiSimKMD/lO544="
  },
  {
    "num_cand": "U2FsdGVkX19aw25Ll2DOqMjXWirnWFWgvMyUeHgBzaM=",
    "cpf": "U2FsdGVkX1/RWv+OL/qb1khowXy1+rKPK/nEOtdWbQQ="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2113/2113_rec_po/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
